export default "__VITE_ASSET__BY51OjbL__"